<button title="{{ 'akcja.wybierz-jezyk' | translate }}" class="flag-button" [nbContextMenu]="langMenu" [nbContextMenuTag]="langMenuTag">
  <i [class]="getLangIcon()"></i>
</button>